/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {useEffect} from "react";
import { Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { Layout, LayoutSplashScreen } from "../_metronic/layout";
import BasePage from "./BasePage";
import { AuthPage } from "./modules/Auth";
import { verifyAuthTokenAsync } from "./modules/Auth/_redux";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";

export function Routes() {

    const dispatch = useDispatch();

    const { isAuthorized, tokenVerified } = useSelector(
        ({ auth }) => ({
            isAuthorized: auth.authToken && auth.user && auth.user.isOTPVerified && auth.user.isProfileSet,
            tokenVerified: auth.tokenVerified,
        }),
        shallowEqual
    );

    useEffect(() => {
        if(!tokenVerified) {
            dispatch(verifyAuthTokenAsync());
        }
    }, [tokenVerified])

    if(!tokenVerified) {
        return <LayoutSplashScreen />
    }


    return (
        <Switch>
            {!isAuthorized ? (
                /*Redirect to `/auth` when user is not authorized*/
                <Route>
                    <AuthPage />
                </Route>
            ) : (
                    // <Redirect from="/" to="/dashboard" />
                    <Layout>
                        <Route>
                            <BasePage />
                        </Route>
                    </Layout>
                )}
            <Route path="/error" component={ErrorsPage} />
        </Switch>
    );
}
